/**
 * Application constants
 */

export const GROQ_MODEL = process.env.REACT_APP_GROQ_MODEL || "llama-3.3-70b-versatile";

export const API_CONFIG = {
  groq: {
    baseUrl: "https://api.groq.com/openai/v1",
    defaultMaxTokens: 1000,
    summaryMaxTokens: 1200,
  },
};

// Firebase config placeholder
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
};

export const DEMO_CREDENTIALS = {
  doctor: {
    email: "sarah@clinic.com",
    password: "doctor123",
  },
  patient: {
    email: "alex@email.com",
    password: "patient123",
  },
};
